import FilterSection from "@SearchResults/features/sidebar/components/FilterSection";
import CompanyScoreFilterButton
    from "@SearchResults/features/sidebar/features/companyFilters/components/CompanyScoreFilterButton";
import getVisibleCompanyScores
    from "@SearchResults/features/sidebar/features/companyFilters/functions/getVisibleCompanyScores";
import {SearchResultsRtkQueryResponseType} from "@SearchResults/api/types/SearchResultsRtkQueryResponse.type";
import useActiveTabFromParams from "@SearchResults/hooks/useActiveTabFromParams";
import useFlixbusViaTravelierConnectExperiment
    from "@SearchResults/features/experiments/hooks/useFlixbusViaTravelierConnectExperiment";
import ParamsType from "@SearchResults/types/params/Params.type";

type CarrierScoreFilterProps = {
    searchData: SearchResultsRtkQueryResponseType,
    params?: ParamsType
}

function CompanyScoreFilter({searchData, params}: CarrierScoreFilterProps) {
    const activeTab = useActiveTabFromParams()
    
    // Apply the same experiment filter logic that's used in usePrepareAndSortRoutes
    const {prepareRoutesForExperiment} = useFlixbusViaTravelierConnectExperiment(params as ParamsType)
    const rawRoutes = searchData.result.singleRoutes[activeTab]
    const filteredRoutes = params ? prepareRoutesForExperiment(rawRoutes) : rawRoutes
    
    // Only show score ranges that have visible routes after filtering
    const visibleCompanyScores = getVisibleCompanyScores(filteredRoutes)
    
    if (visibleCompanyScores.length === 0) {
        return null
    }

    return (
        <FilterSection
            translationKey="search_results.filter_by.company_score.label"
            isToggleable
        >
            {visibleCompanyScores.map((companyScore) => (
                <CompanyScoreFilterButton
                    key={companyScore.label}
                    companyScore={companyScore}
                />
            ))}
        </FilterSection>
    );
}

export default CompanyScoreFilter;